import axios from '@/plugins/axios.js'

export function list(params) {
    return axios.get("erp/supplier/list", { params: params });
}

export function detail(id){
    return axios.get("erp/supplier/"+id);
}

export function remove(id){
    return axios.delete("erp/supplier/"+id);
}

export function save(params) {
    return axios.post("erp/supplier/save", params);
}

export function update(params) {
    return axios.post("erp/supplier/update", params);
}